import { EventBus } from "../EventBus.js";
import FormSelect from "../form-components/FormSelect.vue";
import FormInput from "../form-components/FormInput.vue";
import FormAlert from "../form-components/FormAlert.vue";
import FormTextarea from "../form-components/FormTextarea.vue";

export default {
  components: {
    FormInput,
    FormSelect,
    FormAlert,
    FormTextarea,
  },

  props: {
    endpoint: {
      type: String,
    },
    method: {
      type: String,
      validator(value) {
        // The value must match one of these strings
        return (["post", "put"].indexOf(value) !== -1);
      },
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },

  data() {
    return {
      mutableData: this.data,
      file: "",
      outcome: {
        message: "",
        status: "",
      },
      isSending: false,
      isSuccess: false,
    };
  },

  mounted() {
    if (this.method === "put") {
      axios({
        method: "get",
        url: this.endpoint,
      })
        .then((response) => {
          this.mutableData = response.data;
        });
    }
  },

  methods: {
    displayServerErrors(errors) {
      // reset outcome message
      this.outcome.message = "";

      Object.keys(errors).forEach((key) => {
        this.outcome.message += `${errors[key][0]} <br />`;
      });
    },
    submitForm() {
      // send AJAX request
      this.axiosRequest({
        method: this.method,
        url: this.endpoint,
        data: this.mutableData,
      });
    },
    submitMultiPartForm() {
      const formData = new FormData();

      // append all form data
      for (var key in this.mutableData) {
        if (Array.isArray(this.mutableData[key])) {
          // append as array
          this.mutableData[key].forEach((value) => formData.append(`${key}[]`, value));
        } else {
          // append as string
          formData.append(key, this.mutableData[key]);
        }
      }

      // attach file?
      if (this.files) {
        for (const key in this.files) {
          if (this.files[key]) {
            formData.append(key, this.files[key]);
          }
        }
      }

      // force PUT request, even though it's actually a POST request
      if (this.method === "put") {
        formData.append("_method", "put");
      }

      this.axiosRequest({
        method: "post",
        url: this.endpoint,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    axiosRequest(params) {
      // before AJAX request
      this.isSending = true;
      this.isSuccess = false;
      this.outcome.status = "success";
      this.outcome.message = "Please wait...";

      axios(params)
        .then((response) => {
          // mark as completed if this is a 'create' HTTP request
          if (this.method === "post") {
            this.isSuccess = true;
          }

          this.outcome.status = "success";
          this.outcome.message = response.data.message;

          EventBus.$emit("form-submit-success", response.data);

          // redirect to page
          if (response.data.target) {
            window.location = response.data.target;
          }
        })
        .catch((error) => {
          this.isSuccess = false;
          this.outcome.status = "error";

          if (error.response.data.errors) {
            // display server validation errors
            this.displayServerErrors(error.response.data.errors);
          } else {
            // display error message
            this.outcome.message = error.response.data.message;
          }

          this.$emit("form-submit-error");
        })
        .finally(() => {
          this.isSending = false;
        });
    },
  },
};
